import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.61987 4.75672C3.61987 3.42597 5.0434 2.58012 6.212 3.21548L15.8493 8.45898C17.0701 9.12397 17.0701 10.8765 15.8493 11.5407L6.212 16.7842C5.0434 17.4203 3.61987 16.5737 3.61987 15.2437V4.75672Z",
		fill: "#1A947E"
	})
});
export default SvgPlay;
